export default "__VITE_ASSET__41f51260__"